import React from "react";
import { FormHelperText, Typography } from "@mui/material";
import Input from "@components/Input/Input";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";
import { incidentsOnlySchema } from "../schemas/approvedByMDSludgeDisposalSchema";

const LANG_BASE = "vessel-call.port-services";
const TEXTAREA_MAX_CHARS = 2500;

const IncidentsField = () => {
  const { t } = useTranslation();
  const { setIncidents, incidents, errors, setErrors } = usePortServicesFlow();

  const charCounterSx = {
    ml: 0,
    mt: 0.5,
    fontSize: 12,
    textAlign: "right",
    color: "text.secondary",
  };

  const isPrintableKey = (e: React.KeyboardEvent) =>
    e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;

  return (
    <div className="flex flex-col gap-2" data-testid="port-services-notes">
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t(`${LANG_BASE}.fields.incidents`)}
      </Typography>
      <Input
        multiline
        testId={"incidents-input"}
        value={incidents}
        slotProps={{ htmlInput: { maxLength: TEXTAREA_MAX_CHARS } }}
        placeholder={t(`${LANG_BASE}.fields.incidents`)}
        sx={{ "& textarea": { padding: "12px", borderRadius: "8px" } }}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (!isPrintableKey(e)) return;
          if (incidents.length >= TEXTAREA_MAX_CHARS) {
            setErrors({
              ...errors,
              incidents: t("form-validation.max-length", {
                label: t(`${LANG_BASE}.fields.incidents`),
                max: TEXTAREA_MAX_CHARS,
              }),
            });
          }
        }}
        onBlur={() => {
          const res = incidentsOnlySchema().safeParse({ incidents });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, incidents: flat.incidents?.[0] });
          } else {
            setErrors({ ...errors, incidents: undefined });
          }
        }}
        onChange={(e) => {
          const val = e.target.value;
          setIncidents(val);
          const res = incidentsOnlySchema().safeParse({ incidents: val });
          if (!res.success) {
            const flat = res.error.flatten().fieldErrors;
            setErrors({ ...errors, incidents: flat.incidents?.[0] });
          } else {
            setErrors({ ...errors, incidents: undefined });
          }
        }}
      />
      {errors.incidents && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>{errors.incidents}</FormHelperText>
      )}
      <FormHelperText sx={charCounterSx}>
        {incidents.length}/{TEXTAREA_MAX_CHARS}
      </FormHelperText>
    </div>
  );
};

export default IncidentsField;
